<template>
  <div>
    <!-- <div class="right-action">
      <el-button @click="goBack()">返回</el-button>
    </div> -->
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="待评价" name="order1">
        <span slot="label">待评价（{{ total }}）</span>
        <el-table :data="list" style="width: 100%">
          <el-table-column label="商品图片" align="center">
            <template slot-scope="scope">
              <div @click="handleShop(scope.row)">
                <el-image
                  style="width: 100px; height: 100px; cursor: pointer"
                  :src="scope.row.productPic"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="orderSn" label="订单编号" align="center" />
          <el-table-column prop="productName" label="商品名称" align="center" />
          <el-table-column label="属性" align="center">
            <template slot-scope="scope">{{ scope.row.productAttr | formatProductAttr }}</template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="handleEdit(scope.row)">
                评价
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <div class="block" style="margin-top: 15px">
          <el-pagination
            :current-page="orderParam.pageNum"
            :page-sizes="[10, 15, 20, 25]"
            :page-size="orderParam.pageSize"
            layout="total,sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </el-tab-pane>
      <el-tab-pane label="已评价" name="order2">
        <span slot="label">已评价（{{ commentedTotal }}）</span>
        <el-table :data="commentedList" style="width: 100%">
          <el-table-column label="商品图片" align="center">
            <template slot-scope="scope">
              <div @click="handleShop(scope.row)">
                <el-image
                  style="width: 100px; height: 100px; cursor: pointer"
                  :src="scope.row.productPic"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="orderSn" label="订单编号" align="center" />
          <el-table-column prop="productName" label="商品名称" align="center" />
          <el-table-column prop="productAttr" label="属性" align="center">
            <template slot-scope="scope">{{ scope.row.productAttr | formatProductAttr }}</template>
          </el-table-column>
          <!-- <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              {{ scope.row.status | formatStatus }}
            </template>
          </el-table-column> -->
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="handleDetail(scope.row)">
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <div class="block" style="margin-top: 15px">
          <el-pagination
            :current-page="commentedOrderParam.pageNum"
            :page-sizes="[10, 15, 20, 25]"
            :page-size="commentedOrderParam.pageSize"
            layout="total,sizes, prev, pager, next, jumper"
            :total="commentedTotal"
            @size-change="handleSizeChangeRated"
            @current-change="handleCurrentChangeRated"
          />
        </div>
      </el-tab-pane>
    </el-tabs>
    <evaluate-detail ref="evaluateDetail" />
  </div>
</template>
<script>
import { waitComment, commentedList } from '@/api/evaluate.js'
import EvaluateDetail from './evaluateDetail.vue'
import { productDetailHaveLoggedIn } from '@/api/product'
export default {
  name: 'Evaluate',
  components: { EvaluateDetail },
  filters: {
    formatStatus(type) {
      if (type === 0) {
        return '待审核'
      } else if (type === 1) {
        return '审核通过'
      } else if (type === 2) {
        return '审核驳回'
      }
    },
    formatProductAttr(value) {
      if (value == null) {
        return ''
      } else {
        const attr = JSON.parse(value)
        let result = ''
        for (let i = 0; i < attr.length; i++) {
          result += attr[i].key
          result += ': '
          result += attr[i].value
          result += ';'
        }
        return result
      }
    }
  },
  props: {
    status: {
      type: Number,
      default: () => {
        return 0
      }
    }
  },
  data() {
    return {
      list: [],
      total: 0, // 总条数
      pageSize: 10, // 每页的数据条数
      orderParam: {
        pageNum: 1,
        pageSize: 10
      },
      activeName: 'order1',
      commentedList: [],
      commentedTotal: 0, // 总条数
      commentedOrderParam: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  mounted() {
    this.getOrderList()
    this.getOrderListRated()
  },
  methods: {
    // 每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.orderParam.pageNum = 1
      this.orderParam.pageSize = val
      this.getOrderList()
    },
    // 当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.orderParam.pageNum = val
      this.getOrderList()
    },
    // 查询未评价列表
    getOrderList() {
      const params = {
        pageNum: this.orderParam.pageNum,
        pageSize: this.orderParam.pageSize
      }
      waitComment(params).then(res => {
        if (res.code === 200) {
          this.list = res.data.list
          this.total = res.data.total
        } else {
          this.list = []
        }
      })
    },
    // 每页条数改变时触发 选择一页显示多少行
    handleSizeChangeRated(val) {
      this.commentedOrderParam.pageNum = 1
      this.commentedOrderParam.pageSize = val
      this.getOrderListRated()
    },
    // 当前页改变时触发 跳转其他页
    handleCurrentChangeRated(val) {
      this.commentedOrderParam.pageNum = val
      this.getOrderListRated()
    },
    // 查询已评价列表
    getOrderListRated() {
      const params = {
        pageNum: this.commentedOrderParam.pageNum,
        pageSize: this.commentedOrderParam.pageSize
      }
      commentedList(params).then(res => {
        if (res.code === 200) {
          this.commentedList = res.data.list
          this.commentedTotal = res.data.total
        } else {
          this.commentedList = []
        }
      })
    },
    // 编辑
    handleEdit(row) {
      // console.log(row)
      this.$router.push({
        path: '/home/evaluateEdit',
        query: {
          id: row.id // 指定值或者获取的值
        }
      })
    },
    // 返回
    goBack() {
      this.$router.push({
        name: 'myOrder'
      })
    },
    // 详情
    handleDetail(row) {
      // console.log(row)
      this.$refs.evaluateDetail.show(row)
    },
    handleClick(tab, event) {
      this.getOrderList()
      this.getOrderListRated()
    },
    // 跳转商品详情
    handleShop(val) {
      // console.log(val)
      productDetailHaveLoggedIn(val.productId).then(res => {
        if (res.code === 200) {
          this.$router.push({
            path: '/goodsDetail',
            query: {
              id: val.productId
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.right-action {
  position: absolute;
  right: 60px;
  top: 124px;
  z-index: 9;
}
</style>
